<div class="confirmation-dialog-container">
    <h2 mat-dialog-title  align="center">Reset Password</h2>
    
    <form (ngSubmit)="f.form.valid && onConfirmation()" #f="ngForm" novalidate>
        <mat-dialog-content>
        <span>Are you sure you want to  set new password for '{{ data.value.name }}' from the user list ?</span>
            <!-- NEW PASSWORD -->
            <div class="form-group">
                <mat-form-field>
                    <input
                        passwordValidator
                        type="password"
                        matInput
                        placeholder="New Password"
                        minlength="8"
                        maxlength="32"
                        [(ngModel)]="newPassword"
                        name="newpwd"
                        #newpwd="ngModel"
                        required
                    >
                    <mat-error *ngIf="newpwd.value?.length > 0 && newpwd.touched && newpwd.hasError('passwordValidator')">Please enter valid password</mat-error>
                </mat-form-field>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="center">
        <button
            tabindex="-1"
            mat-dialog-close
            mat-raised-button
            color="basic"
            class="mat-button-medium"
            [mat-dialog-close]="true"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            color="primary"
            class="mat-button-medium"
            type="submit"
            [mat-dialog-close]="true"
            [disabled]="!f.valid"
        >
        Reset Password
        </button>
        </mat-dialog-actions>
    </form>
  </div>
  